import axios from 'axios'

const permissionamento = axios.create({
    baseURL: process.env.VUE_APP_URL_LISTA_PERMISSAO
});

permissionamento.defaults.params = {};

permissionamento.interceptors.request.use(async request => {
    request.baseURL = process.env.VUE_APP_URL_LISTA_PERMISSAO
    request.headers['AppKey'] = process.env.VUE_APP_KEY_PERMISSIONAMENTO
    request.headers['Authorization'] = 'Bearer ' + localStorage.getItem('tokenApi')

    return request
})

export default permissionamento;



// WEBPACK FOOTER //
// ./src/plugins/PermissionamentoInterceptor.js